var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionSuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_6631_2168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.45 12.63L15.31 25.76L7.55001 18C7.28479 17.7348 7.13579 17.3751 7.13579 17C7.13579 16.6249 7.28479 16.2652 7.55001 16C7.81522 15.7348 8.17493 15.5858 8.55001 15.5858C8.92508 15.5858 9.28479 15.7348 9.55001 16L15.33 21.78L26.47 10.65C26.6013 10.5187 26.7572 10.4145 26.9288 10.3434C27.1004 10.2724 27.2843 10.2358 27.47 10.2358C27.6557 10.2358 27.8396 10.2724 28.0112 10.3434C28.1828 10.4145 28.3387 10.5187 28.47 10.65C28.6013 10.7813 28.7055 10.9372 28.7766 11.1088C28.8476 11.2804 28.8842 11.4643 28.8842 11.65C28.8842 11.8357 28.8476 12.0196 28.7766 12.1912C28.7055 12.3628 28.6013 12.5187 28.47 12.65L28.45 12.63Z",
    fill: "#2BC67B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6631_2168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSuccess);
export default __webpack_public_path__ + "static/media/transaction_success.05c86afc59db6cf0c9a646cf4f6b9c59.svg";
export { ForwardRef as ReactComponent };